export const validEmail = (email: string) =>
    /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email);
